import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import IBaseState from '../../types/IBaseState';
import AuthService from '../services/AuthService';
import { LOGOUT } from '../../constants/actions/auth.constants';
import { IAuthTokens } from '../../types';

const NAME = 'AUTH';

const requestResetPassword = createAsyncThunk(
    `${NAME}/requestResetPassword`,
    AuthService.requestResetPassword,
);
const resetPassword = createAsyncThunk(
    `${NAME}/resetPassword`,
    AuthService.resetPassword,
);
const login = createAsyncThunk(`${NAME}/login`, AuthService.login);
const selectCustomer = createAsyncThunk(
    `${NAME}/selectCustomer`,
    AuthService.setCustomer,
);

type AuthState = {
    password: { request: IBaseState<any>; reset: IBaseState<any> };
    login: IBaseState<IAuthTokens[] | undefined>;
};

const initialState: AuthState = {
    password: {
        request: {
            data: null,
            loading: false,
            success: false,
            error: false,
        },
        reset: {
            data: null,
            loading: false,
            success: false,
        },
    },
    login: {
        data: undefined,
        loading: false,
        error: false,
    },
};

const slice = createSlice({
    name: NAME,
    initialState,
    reducers: {
        reinit: (state) => {
            state.password = initialState.password;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(login.pending, (state) => {
            state.login.loading = true;
        });
        builder.addCase(login.fulfilled, (state, action) => {
            state.login.loading = false;
            state.login.data = action.payload.data;
        });
        builder.addCase(login.rejected, (state, action) => {
            state.login.loading = false;
            state.login.data = undefined;
            state.login.error = action.error.message;
        });

        builder.addCase(requestResetPassword.pending, (state) => {
            state.password.request.loading = true;
            state.password.request.success = false;
        });
        builder.addCase(requestResetPassword.fulfilled, (state) => {
            state.password.request.loading = false;
            state.password.request.success = true;
        });
        builder.addCase(requestResetPassword.rejected, (state) => {
            state.password.request.loading = false;
            state.password.request.success = false;
            state.password.request.error = true;
        });

        builder.addCase(resetPassword.pending, (state) => {
            state.password.reset.loading = true;
            state.password.reset.success = false;
        });
        builder.addCase(resetPassword.fulfilled, (state) => {
            state.password.reset.loading = false;
            state.password.reset.success = true;
        });
        builder.addCase(resetPassword.rejected, (state) => {
            state.password.reset.loading = false;
            state.password.reset.success = false;
        });
        builder.addCase(LOGOUT, () => initialState);
    },
});

const AuthActions = {
    requestResetPassword,
    resetPassword,
    login,
    selectCustomer,
    ...slice.actions,
};

export default AuthActions;
export const AuthReducer = slice.reducer;
